import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="52" height="52" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M38.42 1.15a1.65 1.65 0 00-2.33.04L12 25.99l24.2 24.78a1.5 1.5 0 002.15-2.1l-22.16-22.7L38.45 3.07c.52-.54.5-1.39-.03-1.9z" fill="currentColor" id="$" /></svg>);